import { ReactComponent as Icon } from "../assets/icons/chats/Audiocall.svg";
import genIcons from "./genIcons";

const Audiocall = { Outline: genIcons(Icon, { htmlColor: "transparent" }) };

export default Audiocall;
